import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import {
    CircularProgress,
    Divider,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText
} from "@mui/material";
import React, {useState} from 'react';
import {useTranslation} from "react-i18next";
import {useAuth} from '../../context/AuthContext';
import {useProfile} from '../../context/ProfileContext';
import {useRouter} from '../../context/RouterContext';
import ErrorResponseDialog from '../station/components/ErrorResponseDialog';
import DialogLoader from "../common/DialogLoader";

const Profile = () => {
    const {navigate} = useRouter();
    const {user, logout} = useAuth();
    const {profile} = useProfile();
    const {t} = useTranslation();
    const [error, setError] = useState<TemplateStringsArray | undefined>();
    const [loading, setLoading] = useState(false);

    if (!profile) {
        logout()
        navigate('/')
    }

    const onLogout = () => {
        logout()
        navigate('/')
    }
    const onChangePassword = () => {
        // TODO: Change this popup opening to a proper password changing route
        window.open('https://www.tcs.ch/global/wGlobal/scripts/php/ecare/auth/passwordReset.php', 'popup', 'width=600,height=600');
        return false;
    }

    return (
        <>
            {
                loading &&
                <DialogLoader loading={loading} onClose={() => setLoading(!loading)}/>
            }
            {
                error &&
                <ErrorResponseDialog errorCode={error as TemplateStringsArray} onClose={() => {
                    setError(undefined)
                }}/>
            }
            {!profile && <CircularProgress/>}
            {profile && <div className="profile">
                {profile?.tcsRef && <div className="tcs-account">
                    <div>
                        <p>
                            <b>
                                {t('TCS Online Account')}
                            </b>
                        </p>
                        <p>
                            N° {profile?.tcsRef}
                        </p>
                    </div>
                </div>
                }
                <div className="actions">
                    <List>
                        <ListItem>
                            <ListItemButton onClick={onChangePassword}>
                                <ListItemText primary={t('Change password')}/>
                                <ListItemIcon>
                                    <ChevronRightIcon fontSize='large'/>
                                </ListItemIcon>
                            </ListItemButton>
                        </ListItem>
                    </List>
                    {user && <>
                        <Divider/>
                        <List>
                            <ListItem>
                                <ListItemButton onClick={onLogout}>
                                    <ListItemText primary={t('logout')}/>
                                    <ListItemIcon>
                                        <PowerSettingsNewIcon fontSize='large'/>
                                    </ListItemIcon>
                                </ListItemButton>
                            </ListItem>
                        </List>
                    </>
                    }
                </div>

            </div>
            }

        </>

    )
}

export default Profile
